<template>
  <div>
    <div hidden>
      <v-autocomplete />

      <v-combobox />
    </div>
    <!-- {{ vModel }} -->

    <v-menu ref="menu" :min-width="width" v-if="!dontShow && itemColor" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-if="!dontShow && itemColor"
          :style="'width: ' + width"
          v-model="search"
          :label="label"
          v-bind="attrs"
          @click="on.click"
          append-icon="mdi-close"
          @click:append="resetModel()"
          type="text"
        >
        </v-text-field>
      </template>

      <v-list :max-height="height">
        <v-list-item
          @click="getModel(item)"
          v-for="(item, index) in filteredItems"
          :key="index"
          :style="'background-color: ' + item.color"
        >
          <span style="color: white"> {{ getItemText(item) }} </span>
        </v-list-item>
      </v-list>
    </v-menu>
    <!--  -->
    <!-- {{ comboItems }} -->
    <!-- model:{{ model }} -->

    <v-component
      :is="userEntry ? `v-combobox` : `v-autocomplete`"
      v-if="!dontShow && !itemColor"
      ref="ac"
      :readonly="readonly"
      v-model="model"
      :items="comboItems"
      hide-no-data
      :item-text="text"
      :item-value="value"
      :label="label"
      :outlined="outlined"
      autocomplete="password"
      :name="nope()"
      @input="
        onChange ? onChange($event, parentModel) : onChangeFn ? doOnChange($event) : null
      "
      :k="k"
      :key="formKey"
      :clearable="!notClearable"
      :return-object="returnObject"
      :multiple="multiple"
      :chips="chips"
      :class="compclass"
      :placeholder="placeholder"
    >
    </v-component>
    <div>
      <v-add-to-table-button
        v-if="schemaProperties"
        :dialog="dialog"
        class="ml-n8"
        :addButtonCaption="addButtonCaption"
        :save="save"
        :schema="schemaProperties"
        :model="newItemModel"
        :objectName="objName"
        :defaultModel="defModel"
        :formModel="formModel"
      ></v-add-to-table-button>
    </div>
  </div>
</template>

<script>
import { type } from "jquery";
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  props: {
    vModel: [Object, Array, String, Number],
    label: String,
    objName: String,
    dataName: String,
    itemText: String,
    itemValue: String,
    itemColor: String,
    qry: [Object, String],
    qryFn: String,
    pipeline: [Object, String],
    width: String,
    height: String,
    conditionalObject: Array,
    portal_id: String,
    items: [Array, String],
    default: Object,
    defaultIndex: [Number, String],
    defaultItemName:String,
    schema: Object,
    k: String,
    multiple: Boolean,
    chips: Boolean,
    returnObject: Boolean,
    onChange: Function,
    userEntry: Boolean,
    getItems: Boolean,
    capitalizeText: Boolean,
    compclass: String,
    placeholder: String,
    parentItem: Object,
    notClearable: Boolean,
    outlined: Boolean,
    parentModel: [Object, Array],
    onValueChange: Function,
    fields: Array,
    formModel: [Object, Array],
    addItemsFromFormModel: Array,
    addItemsTextPrefix: String,
    textPrefix: String,
    getFromParent: String,
    addButtonCaption: String,
    defaultModel: Object,
    getDefaultModel: String,
    getFilter: String,
    filter: String,
    searchTerm: Object,
    ctlName: String,
    readonly: Boolean,
    objId: String,
    unselectable: String,
    onChangeFn: String,
    topParent: Object,
    addItems: Array,
    hide_if_one_record: Boolean,
  },
  data: () => ({
    defaultItem: true,
    comboItems: [],
    originalItems: [],
    model: null,
    text: "",
    value: "",
    dontShow: false,
    selectionChange: null,
    searchInput: null,
    formKey: 0,
    dialog: false,
    objectName: "",
    schemaProperties: null,
    hiddenProperties: [],
    newItemModel: {},
    defModel: null,
    itemAdded: false,
    search: "",
    showList: false,
    menu: false,
    selectedItem: null,
  }),

  components: {
    VAddToTableButton: () => import("../components/AddToTableButton.vue"),
  },
  methods: {
    userEntryChanged(e) {
      console.log(e);
    },
    getLabel() {
      if (!this.model) {
        return "Select " + this.label;
      } else {
        return "Selected: " + this.getItemText(this.model);
      }
    },
    getModel(m) {
      this.model = m;
      this.search = this.getItemText(this.model);
    },
    resetModel() {
      this.model = null;
      this.search = "";
      // this.$refs.ac.value = "";
    },
    nope() {
      return fun.nope();
    },
    doOnChange(e) {
      // var p = this.formModel;
      // var formatDate = fun.formatDate;
      // try {
      //   eval(this.onChangeFn);
      // } catch (error) {
      //   //
      // }
    },
    save(model) {
      var that = this;
      var newItem = {};
      newItem[that.itemText] = model[that.itemText];
      newItem[that.itemValue] = model[that.itemValue];
      var data = {
        metadata: { object_name: this.dataName || this.objName },
        model: model,
      };

      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true,
        })
        .then(function (response) {
          that.model = model;
          that.itemAdded = true;

          that.comboItems.push(newItem);
          // that.init();
        });
    },
    checkFilter() {
      if (this.filter) {
        var that = this;
        this.comboItems = fun.clone(this.originalItems);
        var p = this.formModel;
        this.comboItems = this.comboItems.filter((r) => {
          try {
            if (!eval(that.readOnlyFormula)) {
              return eval(that.filter);
            } else {
              return true;
            }
          } catch (error) {
            console.log(error);
            return true;
          }
        });
        // this.formKey = !this.formKey;
      }
    },
    getItemText(item) {
      if (item[this.itemText]) {
        return item[this.itemText];
      }
      var path = this.itemText.split(".");
      var v = item;
      path.forEach((p) => {
        v = v[p];
      });

      return v;
    },
    getTopParent() {
      try {
        var par = fun.getParentByProperty(this, this.topParent.parentProperty);
        return par[this.topParent.parentObject];
      } catch (error) {
        return null;
      }
    },
    init() {
      var that = this;
      if (this.items && !Array.isArray(this.items)) {
        this.comboItems = this.items.split(",");
      } else {
        this.comboItems = this.items;
      }
      if (this.getFromParent) {
        var parentModel = this.parentModel;
        if (this.topParent) {
          parentModel = this.getTopParent();
        }
        var cap = fun.capitalize;
        try {
          var i = eval(this.getFromParent);

          this.comboItems = i;
          if (this.defaultIndex != undefined && !this.model) {
            this.model = this.comboItems[this.defaultIndex];
          }
        } catch (error) {
          // console.log("getFromParent", error);
        }
      }
      var vBind = this;

      if (this.schema) {
        vBind = this.schema[this.k]["v-bind"];
        Object.keys(vBind).forEach(function (p) {
          that[p] = vBind[p];
        });
      }
      if (this.conditionalObject) {
        var p = this.formModel;

        var cond = this.conditionalObject.filter((c) => {
          return eval(c.condition);
        });
        if (cond.length) {
          if (!cond[0].items) {
            vBind.objName = cond[0].objName;
            vBind.qry = cond[0].qry;
            vBind.portal_id = cond[0].portal_id;
            vBind.itemValue = cond[0].itemValue;
            vBind.itemText = cond[0].itemText;
          } else {
            this.comboItems = cond[0].items;
          }
        }
      }
      var objName = vBind.objName;
      this.text = vBind.itemText || "text";
      this.value = vBind.itemValue || "value";
      var capitalize = vBind.capitalizeText || this.capitalizeText;
      var localItems = false;

      if (!objName) {
        objName = vBind.objName;

        if (!objName) {
          localItems = true;
          if (!this.comboItems) {
            this.comboItems = vBind.items;
          }

          if (!Array.isArray(this.comboItems) && this.comboItems) {
            this.comboItems = this.comboItems.split(",");
          }
          if (!this.comboItems && vBind.parentObject) {
            this.comboItems = this.parentModel[vBind.parentObject];
          }
          if (this.comboItems) {
            this.comboItems = this.comboItems.filter((c) => {
              return typeof c == "string" || (c.value && typeof c.value == "string");
            });
            this.initItems(capitalize, vBind.itemText);
          }
        } else {
          this.text = vBind.itemText;
          this.value = vBind.itemValue;
        }
      }
      if (this.getItems && (!this.items || this.items.length == 0)) {
        if (this.itemFn) {
          //
        }

        this.$root.$on("update_combo_items", function () {
          that.$root.$emit("get_combo_items", that);
        });
        this.$root.$emit("get_combo_items", this);
      } else {
        if (!localItems) {
          if (!this.getItems && !this.getFromParent) {
            var fields = []; //""
            if (!vBind.allFields) {
              if (vBind.itemText != vBind.itemValue) {
                fields.push(vBind.itemText);
                fields.push(vBind.itemValue);
              } else if (vBind.itemValue) {
                fields.push(vBind.itemValue);
              }
              if (vBind.additionalFields) {
                vBind.additionalFields.forEach((f) => {
                  fields.push(f);
                });
              }
            }
            if (vBind.itemColor) {
              fields.push(vBind.itemColor);
            }

            var url = this.serverURL + "/get_records";
            if (vBind.permittedQry) {
              try {
                this.$root.store.permittedActions.forEach((permittedActions) => {
                  if (eval(vBind.permittedQry)) {
                    var qry = eval(vBind.permittedQry).replaceAll("`", '"');
                    vBind.qry = JSON.parse(qry);
                  }
                });
              } catch (error) {
                //
              }
            }
            var data = {
              object_name: vBind.objName,
              fields: fields,
              qry: vBind.qry,
              pipeline: vBind.pipeline,
              portal_id: vBind.portal_id,
              model: this.vModel,
            };

            axios
              .post(url, data, {
                withCredentials: true,
              })
              .then((response) => {
                // console.log(res);
                that.comboItems = response.data[0];
                that.vModel = response.data[2];
                if (that.getFilter) {
                  var par = fun.getParentByProperty(that, that.getFilter);
                  if (par) {
                    that.comboItems = that.comboItems.filter((r) => {
                      return par[that.getFilter](r);
                    });
                  }
                }
                that.initItems(capitalize, vBind.itemText);
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => (this.isLoading = false));
          }
        }
      }
    },
    initItems(capitalize, itemText) {
      var that = this;
      if (!this.itemAdded) {
        that.model = that.vModel;
      }
      this.itemAdded = false;
      try {
        var defaultIndex = parseInt(that.defaultIndex);
      } catch (error) {
        //
      }
      if (
        (!that.model && !that.model === 0) ||
        (Array.isArray(that.model) && !that.model.length) ||
        (typeof that.model == "object" && !Object.keys(that.model).length)
      ) {
        that.model = "";
      }
      var d = that.model || that.default || {};
      var k = "";

      if (capitalize) {
        if (
          that.comboItems.length &&
          (typeof that.comboItems[0] != "object" || itemText)
        ) {
          that.comboItems = fun.capitalizeItems(
            that.comboItems,
            this.itemText,
            this.itemValue,
            that.fields
          );
        }
        this.text = "text";
        this.value = "value";
      }
      if (that.default && !that.model) {
        defaultIndex = -1;
        k = Object.keys(d)[0];
      } else {
        k = that.value;
      }
      if (
        (!that.model &&
          ((that && that.defaultIndex) || that.defaultIndex == 0) &&
          !that.formModel) ||
        (!that.model && that.formModel && !that.formModel[that.k])
      ) {
        defaultIndex = parseInt(that.defaultIndex);
      } else {
        that.comboItems.forEach(function (item, idx) {
          if (typeof item[k] == "string") {
            if (d && !that.vModel && item[k]) {
              if (
                item[k] &&
                item[k].trim() &&
                d[k] &&
                d[k].trim() &&
                item[k].trim().toLowerCase() == d[k].trim().toLowerCase()
              ) {
                defaultIndex = idx;
              }
            } else if (that.vModel && !that.returnObject) {
              if (
                that.vModel &&
                item[k] &&
                item[k].trim() &&
                item[k].trim().toLowerCase() ==
                  that.vModel.toString().trim().toLowerCase()
              ) {
                defaultIndex = idx;
              }
            } else {
              if (that.vModel) {
                if (
                  that.vModel[that.itemValue] &&
                  item[k] &&
                  item[k].trim().toLowerCase() ==
                    that.vModel[that.itemValue].toString().trim().toLowerCase()
                ) {
                  defaultIndex = idx;
                }
              }
            }
          }
        });
      }
      if (this.addItems) {
        this.comboItems = this.comboItems.concat(this.addItems);
      }
      if (this.textPrefix) {
        this.comboItems.forEach((i) => {
          i[this.itemText] = this.textPrefix + i[this.itemText];
        });
      }

      if (this.addItemsFromFormModel) {
        var addItem = [];
        this.addItemsFromFormModel.forEach((i) => {
          addItem.push(this.formModel[i]);
        });
        addItem = addItem.join(", ");
        var addedItem = {};
        if (this.addItemsTextPrefix) {
          addedItem[this.itemText] = this.addItemsTextPrefix + addItem;
        } else {
          addedItem[this.itemText] = addItem;
        }

        this.comboItems.push(addedItem);
      }
      try {
        this.comboItems.sort((a, b) => {
          return fun.compare(a, b, that.text);
        });
      } catch (error) {
        //
      }
      if (!that.multiple || that.comboItems.length == 1) {
        if (!that.vModel || !that.formModel || !that.formModel[that.k]) {
          if (that.returnObject) {
            if (defaultIndex || defaultIndex == 0) {
              that.model = that.comboItems[defaultIndex];
            }
          } else {
            if (defaultIndex || defaultIndex == 0) {
              that.model = that.comboItems[defaultIndex];
            }
          }
        }
      } else {
        if (that.multiple) {
          if (that.vModel && Array.isArray(that.vModel)) {
            that.model = that.vModel;
          } else {
            that.model = [];
            if (that.comboItems[defaultIndex]) {
              that.model.push(that.comboItems[defaultIndex][that.value]);
            }
          }
        } else if (defaultIndex || defaultIndex == 0) {
          that.model = that.comboItems[defaultIndex][that.value];
        }
      }
      if (that.hide_if_one_record && that.comboItems.length < 2) {
        that.dontShow = true;
      }

      this.originalItems = fun.clone(this.comboItems);
      this.checkFilter();
    },
  },
  watch: {
    formModel: {
      handler: function (newValue, oldValue) {
        this.checkFilter();
      },
      deep: true,
    },
    vModel() {
      if (this.vModel && this.vModel.length) {
        this.model = this.vModel;
      }
    },
    search() {
      console.log(this.search);
    },
    model() {
      if (this.returnObject || typeof this.model != "object" || this.multiple) {
        this.$emit("input", this.model);
      } else if (
        this.model &&
        typeof this.model == "object" &&
        this.itemValue &&
        this.model[this.itemValue]
      ) {
        this.$emit("input", this.model[this.itemValue]);
      }
      // if (this.model) {

      // }

      if (this.selectionChange) {
        this.selectionChange();
      }

      if (this.updateItem) {
        var item = null;
        var searchTerm = this.updateItem.searchTerm;
        if (searchTerm && this.comboItems) {
          item = this.comboItems.filter((r) => {
            return r[searchTerm] == this.model;
          })[0];
        }
        var f = this.formModel;
        var m = item || this.model;
        this.selectedItem = item;
        try {
          eval(this.updateItem.update);
        } catch (error) {
          // console.log(error);
        }
      }
      if (this.onValueChange) {
        this.onValueChange(
          {
            key: this.itemText,
            value: this.model,
          },
          this.parentModel
        );
      }
      var comboItem = null;
      if (this.model && this.comboItems) {
        comboItem = this.comboItems.find((c) => {
          return c[this.itemValue] == this.model || c == this.model;
        });
      }
      this.$root.$emit("comboUpdated", {
        objName: this.objName,
        ctlName: this.ctlName,
        item: comboItem,
        model: this.model,
        selectedItem: this.selectedItem,
        formModel: this.formModel,
        obj: this,
      });
    },
    comboItems() {
      if (this.comboItems && this.hide_if_one_record && this.comboItems.length < 2) {
        this.dontShow = true;
      }
    },
  },
  computed: {
    filteredItems() {
      if (this.search) {
        return this.comboItems.filter((item) =>
          this.getItemText(item).toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        return this.comboItems;
      }
    },
  },
  mounted() {
    var that = this;
    this.model = this.vModel;

    if (this.defaultModel) {
      this.defModel = this.defaultModel;
    }
    if (this.getDefaultModel) {
      var p = fun.getParentByProperty(this, this.getDefaultModel);
      if (p) {
        this.defModel = p[this.getDefaultModel]();
      }
    }
    if (this.addButtonCaption) {
      var d = {
        obj_name: this.dataName || this.objName,
      };
      this.axios
        .post(this.serverURL + "/get_schema", d, {
          withCredentials: true,
        })
        .then(function (response) {
          console.log(response);
          if (that.hiddenProperties.length) {
            that.hiddenProperties.forEach((h) => {
              response.data.properties[h].hidden = true;
            });
          }
          that.schemaProperties = response.data;
        });
    }
    this.init();
  },
};
</script>
